import { injectable } from 'inversify';
import 'reflect-metadata';
import {
  PaginatedResult,
  Response,
} from '@/_shared/_api/models/response.model';
import axiosClient from './axios-client';

@injectable()
export class NewsService {
  async getNews(
    offset: number,
    limit: number,
    paginated?: boolean,
    sortField?: string,
    sortOrder?: number,
    countriesFilter?: string[],
    searchString?: string
  ): Promise<Response<PaginatedResult>> {
    const response = await axiosClient.get('/api/news', {
      params: {
        offset: offset,
        limit: limit,
        timezone: 'UTC',
        paginated: paginated,
        sortField: sortField ?? 'published_on',
        sortOrder: sortOrder,
        countriesFilter: countriesFilter,
        searchString: searchString,
      },
    });

    return response;
  }
}
